import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Copy01, CornerDownLeft } from '@opendate-app/setlist';
import '../../styles/beautifui.css';

const ConductorResponseFooter = ({ content, sources = [], followUps = [], onCopy, onFollowUp = null }) => {
  const [sourcesOpen, setSourcesOpen] = useState(false);
  const sourceLabel = `${sources.length} source${sources.length === 1 ? '' : 's'}`;

  return (
    <div className="bui">
      <div className="bui-response-actions">
        <Button variant="tertiary" size="sm" icon={Copy01} className="bui-icon-button" aria-label="Copy response" title="Copy" onClick={() => onCopy(content)} />
        {sources.length > 0 && (
          <button
            type="button"
            className="bui-sources-toggle"
            aria-expanded={sourcesOpen}
            onClick={() => setSourcesOpen((open) => !open)}
          >
            <span className="bui-source-stack" aria-hidden="true">
              {sources.slice(0, 3).map((source) => (
                <span key={source.key} className="bui-source-avatar">
                  <source.icon width={8} height={8} aria-hidden="true" />
                </span>
              ))}
            </span>
            <span>{sourceLabel}</span>
          </button>
        )}
      </div>

      {sources.length > 0 && (
        <div className={`bui-collapse${sourcesOpen ? ' is-open' : ''}`}>
          <div>
            <div className="bui-sources-list">
              {sources.map((source) => (
                <div key={source.key} className="bui-source-row">
                  <source.icon width={14} height={14} aria-hidden="true" />
                  <span>{source.name}</span>
                  {source.meta && <span className="bui-source-meta">{source.meta}</span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {followUps.length > 0 && onFollowUp && (
        <div className="bui-follow-ups">
          <p className="bui-follow-ups-title">Follow-ups</p>
          {followUps.map((text, index) => (
            <button
              key={text}
              type="button"
              className="bui-follow-up"
              style={{ animationDelay: `${index * 90}ms` }}
              onClick={() => onFollowUp(text)}
            >
              <CornerDownLeft width={11} height={11} aria-hidden="true" />
              {text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

ConductorResponseFooter.propTypes = {
  content: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    meta: PropTypes.string,
    icon: PropTypes.elementType.isRequired
  })),
  followUps: PropTypes.arrayOf(PropTypes.string),
  onCopy: PropTypes.func.isRequired,
  onFollowUp: PropTypes.func
};

export default ConductorResponseFooter;
